var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10498_50048",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 20,
    height: 20,
    transform: "rotate(180 20 20)",
    fill: "url(#pattern0_10498_50048)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10498_50048)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 20,
    height: 20,
    transform: "rotate(180 20 20)",
    fill: "url(#pattern1_10498_50048)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 20,
    height: 20,
    transform: "rotate(180 20 20)",
    fill: "#01924F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_10498_50048",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10498_50048",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_10498_50048",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10498_50048",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10498_50048",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACiUlEQVR4nO3bPW4TQRjGcTfAFciOgYaKllNwBcQBiEKBxAFo5pWAjpJrEK7Ah8ChckUBSeaNhGgQBKgQoMEgrBVO7NV49/Hu/ydNk4yU0T6ZSby7z2gEAMCGmF65e/ZoK97yKr5IIX7xYD/nR8pfq+y5V7aT53a93l47uHC/SiG+roewaKRge/sX41bX6+6l/Nu+Shj+b8dMJlcfnel6/b3z+5haMQz/Oyrb7nr9vZP/ZtSOo8f5CKvPOxzHkELcre2SZ92susdSsOP5i5wv/OK598a1QD63u9oBqB9DpedjRQQihkDEEEhDKdiNFOKHxv+iLjlOW4cvmL/udbU1UrC3KcRrJ16E/AHMq/itjQUNPRDPozI/8SK8ufzwXAr2lUBMI5DscGzXU4jv2SHW/ZG1TqWOLBRCIGIIRAyBiMk3COdD4eai3O33uPu/UFK+01vZk9pcbr+XD8R2mv+/Hm8WX9DQzR7h2l6DMF7yCHdN8gsL+Rn5Cp9kX/GSw5rN7pfZdgr2tP4U0WefYI/z9/Ixxc4AAAAAAADo1JRGl44DGl06pjS6tBzR6NLiNLq0JBpdWpw3KbU4gWhxAtHimxJIWw0qtTE6xaL5vWlQDT0QV2tQqY2RYiBtNqiGHkjqukGlxgsFgkIIRIyzQ7Q4gWhJNLq0OI0uLU6jS8uURpeefRpdeiY0ugAAAAAAQPtoJgmhmSSEZpIYmkliaCaJoZkkhtdrxBCIGAIRQyCFeWV3UrBPm/qav2/IWKqO8O7Sg/MpxO8lfzCBWPPCzp9AfhCItbNTlmlQpRBve2Uf2SHW/ZFVQqkjC4UQiBgCEUMgYmgmiaGZJIZmkhiaSYJoJgmimQQAwKhVvwDB8ut7kcl4rQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.4381d9ef1a93ea26d34bd9f922d59be9.svg";
export { ForwardRef as ReactComponent };